// extracted by mini-css-extract-plugin
export default {"splashScreenContainer":"SplashScreen_splashScreenContainer__nc4xU","fadeOutDown":"SplashScreen_fadeOutDown__FRb9s"};